export default __webpack_public_path__ + "static/media/ketupak.e6257336.png";